// extracted by mini-css-extract-plugin
export var chevron = "_js-2";
export var dropdownItems = "_js-0";
export var item = "_js-1";